import useCartHasFreeTrialBundle from './useCartHasFreeTrialBundle';
import useHardwareFirstCartUnits from './useHardwareFirstCartUnits';

/**
 * Whether the hardware-first cart holds a free trial and no repriced hardware unit. Nothing in it is
 * discountable, so promo codes have no place. Must be called inside a CheckoutContextProvider.
 */
export default function useHardwareFirstTrialOnlyCart(): boolean {
  const hasTrial = useCartHasFreeTrialBundle();
  const units = useHardwareFirstCartUnits();
  return hasTrial && units === 0;
}
